<template>
    <div>
        <inserir-atualizar-anexo-form
            :mostrarModal="mostrarModal"
            :acao="acao"
            :tiposAnexos="tiposAnexos"
            :anexoAtualizar="anexoAtualizar"
            @fechar="$emit('fechar')"
            @inserir=inserirAnexo($event)
            @atualizar=atualizarAnexo($event)
        >
        </inserir-atualizar-anexo-form>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import InserirAtualizarAnexoForm from '@/app/despesasgerais/componentes/despesas/InserirAtualizarAnexoForm.vue';
import DespesasAnexosServicos from './DespesasAnexosServicos'

export default {
    props: {
        mostrarModal: {
            type: Boolean
        },

        acao: {
            type: String
        },  

        anexo: { 
            type: Object
        },

        despesa: { 
            type: Object
        },

        anexoAtualizarId: {
            type: String,
        },
    },

    components: {
        InserirAtualizarAnexoForm
    },

    data() {
        return {
            operacao: 'INSERIR',
            erros: [],
            tiposAnexos: [],
            anexoAtualizar: null
        }
    },

    methods: {
        obterAnexo() {
            this.$store.dispatch('addRequest')
            DespesasAnexosServicos.obterAnexo(this.anexoAtualizarId).then(response => {
                if (response) {
                    if (response.success) {
                        this.anexoAtualizar = response.data
                    } else {
                        this.$toast.error(
                            this.erros = response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        ) 
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        inserirAnexo(anexoDto) {
            anexoDto.despesaId = this.despesa.despesaId
            this.$store.dispatch('addRequest')
            DespesasAnexosServicos.inserirAnexo(anexoDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Anexo salvo com sucesso',
                            'OK',
                            this.$toastConfig.success
                        ) 
                        this.$emit('atualizar')
                    } else {
                        this.$toast.error(
                            this.erros = response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )    
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        atualizarAnexo(anexoDto) {
            anexoDto.despesaId = this.despesa.despesaId
            this.$store.dispatch('addRequest')
            DespesasAnexosServicos.atualizarAnexo(anexoDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Anexo salvo com sucesso',
                            'OK',
                            this.$toastConfig.success
                        ) 
                        this.$emit('atualizar')
                    } else {
                        this.$toast.error(
                            this.erros = response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )    
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterTiposAnexos() {
            this.$store.dispatch('addRequest')
            DespesasAnexosServicos.obterTiposAnexos().then(response => {
                if (response) {
                    if (response.success) {
                        this.tiposAnexos = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter tipos de anexos',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    watch: {
        mostrarModal() {
            if (this.mostrarModal) {
                this.obterTiposAnexos()
                if (this.acao == 'ATUALIZAR') {
                    this.obterAnexo()
                }
            }
        }
    },

    validations: {
        tipoId: {
            required
        },
        arquivo: {
            required
        },
        descritivo: {
            required
        }
    }
}
</script>
